export const QUESTIONS = [
  {
    id: "entity",
    step: 1,
    category: "Foundation",
    question: "Have you set up a legal business entity?",
    options: [
      { label: "No entity yet", points: 0 },
      { label: "Considering / researching it", points: 1 },
      { label: "LLC or corp formed", points: 2 },
      { label: "LLC + EIN + business banking done", points: 3 },
    ],
  },
  {
    id: "authority",
    step: 3,
    category: "Foundation",
    question: "Where are you with your MC/DOT operating authority?",
    options: [
      { label: "Haven't started", points: 0 },
      { label: "Still researching the process", points: 1 },
      { label: "Application in progress", points: 2 },
      { label: "Active authority in hand", points: 3 },
    ],
  },
  {
    id: "capital",
    step: 10,
    category: "Financials",
    question: "How much working capital do you have to launch?",
    options: [
      { label: "Under $5,000", points: 0 },
      { label: "$5,000 – $15,000", points: 1 },
      { label: "$15,000 – $30,000", points: 2 },
      { label: "$30,000+", points: 3 },
    ],
  },
  {
    id: "credit",
    step: 2,
    category: "Financials",
    question: "How is your credit & financing readiness?",
    options: [
      { label: "Poor / not sure", points: 0 },
      { label: "Fair, building it", points: 1 },
      { label: "Good", points: 2 },
      { label: "Excellent + financing lined up", points: 3 },
    ],
  },
  {
    id: "equipment",
    step: 4,
    category: "Operations",
    question: "Do you have a truck / trailer?",
    options: [
      { label: "None yet", points: 0 },
      { label: "Financing or leasing planned", points: 1 },
      { label: "Leased and running", points: 2 },
      { label: "Owned outright", points: 3 },
    ],
  },
  {
    id: "compliance",
    step: 6,
    category: "Operations",
    question: "How well do you understand compliance (ELD, IFTA, BOC-3, insurance)?",
    options: [
      { label: "No idea where to start", points: 0 },
      { label: "Heard of some of it", points: 1 },
      { label: "Understand most of it", points: 2 },
      { label: "Fully understand & set up", points: 3 },
    ],
  },
  {
    id: "experience",
    step: 9,
    category: "Experience",
    question: "Years of professional driving / freight experience?",
    options: [
      { label: "Less than 1 year", points: 0 },
      { label: "1 – 3 years", points: 1 },
      { label: "3 – 7 years", points: 2 },
      { label: "7+ years", points: 3 },
    ],
  },
  {
    id: "loads",
    step: 11,
    category: "Operations",
    question: "How will you find and book loads?",
    options: [
      { label: "No plan yet", points: 0 },
      { label: "Load boards only", points: 1 },
      { label: "Load boards + broker relationships", points: 2 },
      { label: "Established shipper / broker network", points: 3 },
    ],
  },
];

export const MAX_POINTS_PER_Q = 3;
